module.exports = {"411623001":"新城街道","411623002":"东城街道","411623003":"老城街道","411623101":"黄寨镇","411623102":"练集镇","411623103":"魏集镇","411623104":"固墙镇","411623105":"白寺镇","411623106":"巴村镇","411623107":"谭庄镇","411623108":"邓城镇","411623109":"胡吉镇","411623110":"郝岗镇","411623111":"姚集镇","411623112":"张庄镇","411623200":"城关乡","411623202":"平店乡","411623203":"袁老乡","411623204":"化河乡","411623206":"舒庄乡","411623207":"大武乡","411623208":"张明乡","411623211":"汤庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411623.json
// module id = 1801
// module chunks = 0